import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ViewportObserver from '@ynap/viewport-observer';
import DoubleImage from '../DoubleImage/DoubleImage';

class CombinedImage extends PureComponent {
    static propTypes = {
        aspectRatio: PropTypes.string,
        className: PropTypes.string,
        computeAttributes: PropTypes.bool,
        height: PropTypes.number,
        loading: PropTypes.bool,
        secondarySrc: PropTypes.string,
        src: PropTypes.string,
        width: PropTypes.number,
        xOffset: PropTypes.string,
        yOffset: PropTypes.string,
        displayError: PropTypes.bool,
        withIntersectionObserver: PropTypes.bool,
        imageSrcsetSize: PropTypes.string,
        ImageComponent: PropTypes.elementType,
        doubleImageWithoutPadding: PropTypes.string,
        doubleImageModifier: PropTypes.string,
        imageOverlayElement: PropTypes.node,
    };

    render() {
        const {
            className,
            doubleImageModifier,
            doubleImageWithoutPadding,
            imageOverlayElement,
            src,
            withIntersectionObserver = true,
            xOffset = '0px',
            yOffset = '0px',
        } = this.props;

        if (!withIntersectionObserver) {
            return (
                <DoubleImage
                    {...this.props}
                    className={className}
                    doubleImageModifier={doubleImageModifier}
                    doubleImageWithoutPadding={doubleImageWithoutPadding}
                    imageOverlayElement={imageOverlayElement}
                />
            );
        }

        return (
            <ViewportObserver innerKey={src} rootMargin={`0px ${xOffset} ${yOffset} 0px`}>
                {(intersected) => (
                    <DoubleImage
                        {...this.props}
                        className={className}
                        displaySrc={intersected}
                        doubleImageModifier={doubleImageModifier}
                        doubleImageWithoutPadding={doubleImageWithoutPadding}
                        imageOverlayElement={imageOverlayElement}
                    />
                )}
            </ViewportObserver>
        );
    }
}

export default CombinedImage;
